import { useCallback, useState } from "react";
import type { DurationPickerProps, DurationUnit } from "./DurationPicker.types";
import { addDuration, DURATION_PRESETS } from "./durationPicker.helpers";

export const useDurationPickerInternalState = ({ value, onChange, now }: Pick<DurationPickerProps, "value" | "onChange" | "now">) => {
  const [selected, setSelected] = useState<string>(value === null ? "never" : "30d");
  const [amount, setAmount] = useState(2);
  const [unit, setUnit] = useState<DurationUnit>("days");
  const clock = () => now ?? new Date();

  const pickPreset = useCallback(
    (id: string) => {
      setSelected(id);
      if (id === "custom") return onChange(addDuration(clock(), amount, unit));
      const p = DURATION_PRESETS.find((x) => x.id === id);
      if (!p) return;
      onChange(p.amount === null || p.unit === null ? null : addDuration(clock(), p.amount, p.unit));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [amount, unit, onChange, now],
  );
  const changeCustom = useCallback(
    (nextAmount: number, nextUnit: DurationUnit) => {
      setAmount(nextAmount);
      setUnit(nextUnit);
      if (nextAmount > 0) onChange(addDuration(clock(), nextAmount, nextUnit));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, now],
  );
  return { selected, amount, unit, pickPreset, changeCustom };
};
